import { useEffect } from "react";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export type AdSenseSlotProps = {
  className?: string;
  client?: string;
  label?: string;
  responsive?: boolean;
  slot?: string;
};

export function AdSenseSlot({
  className,
  client,
  label = "Advertisement",
  responsive = true,
  slot
}: AdSenseSlotProps) {
  const isConfigured = Boolean(client && slot);

  useEffect(() => {
    if (!isConfigured) {
      return;
    }

    window.adsbygoogle = window.adsbygoogle ?? [];
    window.adsbygoogle.push({});
  }, [isConfigured]);

  if (!isConfigured) {
    return (
      <aside className={className} data-ad-placeholder="true">
        <span>{label}</span>
        <small>AdSense slot reserved</small>
      </aside>
    );
  }

  return (
    <aside className={className} aria-label={label}>
      <ins
        className="adsbygoogle"
        data-ad-client={client}
        data-ad-format="auto"
        data-ad-slot={slot}
        data-full-width-responsive={responsive ? "true" : "false"}
        style={{ display: "block" }}
      />
    </aside>
  );
}

export type GoogleAnalyticsProps = {
  measurementId?: string;
};

export function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {
  if (!measurementId) {
    return null;
  }

  const inlineScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');
  `;

  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <script dangerouslySetInnerHTML={{ __html: inlineScript }} />
    </>
  );
}

export function adSenseLoaderScript(client?: string) {
  if (!client) {
    return null;
  }

  return (
    <script
      async
      crossOrigin="anonymous"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`}
    />
  );
}
